import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import {Divider} from "reakit";
import {Box, Card, Flex, Text} from "rebass";

import moment from 'moment'

const Wrapper = styled(Box)`
	height: 35vh;
  overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
`;
const textProps = {
	ml: 3
};


const WaveSummary = props => {
	const {student, locations, date, leaveTypes} = props;
	const waveList = student ? student.wave : [];
	let currentDayList = [];
	if (student !== null && student.wave.length > 0) {
		// waveList = Object.keys(student.wave_history).map(key => ({

		currentDayList = waveList.filter(wave => moment.unix(wave.post_time).isSame(date, 'day'))
	}

	const locationMap = locations.map;
	const dateString = moment(date).format("MMM D");
	let is_oncampus, name;
	return (
		<Box p={2}>
			<Text p={2} fontSize={'17px'} fontWeight={500}>{dateString}</Text>
			<Card mt={1}>

				<Wrapper flexDirection={'column'} width={1}>
					{currentDayList.reverse().map(wave => {
						if(wave.on_leave) {
							is_oncampus = false;
							name = leaveTypes[wave.leave_type] &&  leaveTypes[wave.leave_type].name
						} else {
							name = locationMap[wave.location_uid] && locationMap[wave.location_uid].name;
							is_oncampus = locationMap[wave.location_uid] && locationMap[wave.location_uid].is_oncampus;
						}
					
						return (<Box key={wave.id} width={1}>
							<Flex >
								<Box width={1/4} pl={2}><Text color={'meta'} fontSize={'15px'}>{moment.unix(wave.post_time).format("H:mm")}</Text></Box>

								{/*<Box ml={4}/>*/}
								<Box>
									<Text key={wave.id} fontWeight={700} fontSize={'15px'}{...textProps}>
									 {is_oncampus? 'ON - ' : 'OFF - '} {name}
									</Text>
									{wave.creator ? <Text color={'meta'} fontSize={'13px'} {...textProps}>by {wave.creator.first_name} {wave.creator.last_name}</Text>
									:
									<Text color={'meta'} fontSize={'13px'} {...textProps}>Loading...</Text>}
								</Box>

							</Flex>
							<Divider marginTop={'5px'} marginBottom={'5px'}/>

						</Box>)
					})}
					<Box pt={4}/>
				</Wrapper>
			</Card>
		</Box>
	);
};

WaveSummary.propTypes = {
	student: PropTypes.object
};

export default WaveSummary;
